module.exports = __webpack_public_path__ + "c4c4d4378f24a72620b9fdc19970d54c.svg";